// extracted by mini-css-extract-plugin
export var dropdownButton = "_1p-0";
export var fullWidthDropdownButton = "_1p-1";
export var icon = "_1p-3";
export var iconPlaceholder = "_1p-2";
export var menuItemRow = "_1p-8";
export var separator = "_1p-c";
export var shortcutContainer = "_1p-7";
export var shortcutIconLg = "_1p-6";
export var shortcutIconMd = "_1p-5";
export var shortcutIconSm = "_1p-4";
export var submenuChevron = "_1p-b";
export var submenuDropdown = "_1p-9";
export var submenuTriggerRow = "_1p-a";